import { css } from "styled-components/macro";

export const visibilityToggleStyles = css`
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: visibility 0s var(--ease) 0.5s, opacity 0.2s var(--ease);

  &.visible {
    opacity: 1;
    visibility: visible;
    transition-delay: 0s;
    pointer-events: all;
  }

  /*
    Guided walkthrough (components/tour). Every surface using these styles is
    hover-revealed — the chart toolbar, both axis field selectors, the
    well-count toggle, the vis toolbars — and the walkthrough spotlights
    controls in most of them. Without this, a step cut its spotlight over
    something invisible, and the control it named could not be clicked (the
    pointer-events: none above) until the user happened to hover the chart.

    Revealed only while the spotlight is actually on this surface or inside it,
    so nothing changes for the rest of the walkthrough. The eva-tour-active
    class is Tour.tsx's own and driver-active-element is driver.js's mark on
    the spotlit node; the :has() arm is what covers a control nested inside one
    of these wrappers, since an ancestor's opacity cannot be undone from the
    descendant.

    NOTE: no backticks in this comment — the block sits inside a
    styled-components template literal, and one would terminate it.
  */
  body.eva-tour-active &.driver-active-element {
    opacity: 1;
    visibility: visible;
    transition-delay: 0s;
    pointer-events: all;
  }

  /*
    Separate rule, not a second selector on the one above: a browser without
    :has() support discards the entire selector list it appears in, which
    would take the plain .driver-active-element arm down with it. Split, the
    spotlit-node case keeps working and only the nested-control case is lost.
  */
  body.eva-tour-active &:has(.driver-active-element) {
    opacity: 1;
    visibility: visible;
    transition-delay: 0s;
    pointer-events: all;
  }
`;
